<template>
  <div class="minimum-payout-threshold">
    <ContentBlock :loading="isLoading">
      <div slot="instructions">
        <h5 class="f5">{{ $tc('Minimum Payout Threshold') }}</h5>
        <p
          class="f5"
        >{{ $t('Set the minimum amount that is required before we will send a payment to your bank account.') }}</p>
      </div>
      <div>
        <div class="minimum">
          <h1 class="f8 grey">{{ $t('Minimum Payout Threshold') }}</h1>
          <div class="value f4">
            {{ minimumPayoutThreshold }}
            <UIButton class="edit-minimum" @click="openModal" :tiny="true" icon="edit"/>
          </div>
        </div>
      </div>
    </ContentBlock>
    <Modal @closeModal="isModalOpen = false" v-if="isModalOpen">
      <div class="modal-content">
        <h1 class="f2">{{ $t('Update your minimum payout threshold') }}</h1>
        <div class="form">
          <UIInput
            class="payout-input"
            type="number"
            :min="(isUSOrg) ? 25 : 50"
            :max="1000"
            step="1"
            :title="$t('Minimum Payout Threshold in USD')"
            :instructions="(isUSOrg) ? $t('Please enter a full dollar amount between 25 and 1,000.') : $t('Please enter a full dollar amount between 50 and 1,000.')"
            :value="payoutThreshold / 100"
            @input="payoutThreshold = $event.target.value * 100"
          />
          <UIButton :ghost="true" @click="isModalOpen = false">{{ $t('Cancel') }}</UIButton>
          <UIButton @click="save" :disabled="disabledButton">{{ $t('Save') }}</UIButton>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import UIButton from '@/core/shared/components/ui/UIButton';
import UIInput from '@/core/shared/components/ui/UIInput';
import Modal from '@/core/shared/components/Modal';

@Component({
  components: {
    ContentBlock,
    UIButton,
    UIInput,
    Modal,
  },
  props: {
    organization: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
  },
})
export default class MinimumPayoutThreshold extends Vue {
  isModalOpen = false;
  payoutThreshold = 0;

  created () {
    this.payoutThreshold = this.organization.payoutThreshold;
  }

  get isUSOrg () {
    return this.organization.country === 'USA';
  }

  get disabledButton () {
    if (this.isUSOrg) {
      return this.payoutThreshold < 2500 || this.payoutThreshold > 100000;
    } else {
      return this.payoutThreshold < 5000 || this.payoutThreshold > 100000;
    }
  }

  get minimumPayoutThreshold () {
    return (this.organization.payoutThreshold / 100).toLocaleString(window.sbvrenv.BROWSER_LOCALE, { style: 'currency', currency: 'USD' });
  }

  openModal () {
    this.payoutThreshold = this.organization.payoutThreshold;
    this.isModalOpen = true;
  }

  save () {
    this.isModalOpen = false;
    this.$emit('edit:organization', 'payoutThreshold', this.payoutThreshold);
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.minimum-payout-threshold {
  & > h1 {
    color: var(--colorManatee);

    margin-bottom: var(--spacingXS);
  }

  & .edit-minimum {
    margin-left: var(--spacingLg);

    & >>> svg {
      fill: var(--colorSlate);
    }
  }

  & .modal-content {
    padding: var(--spacingLg) var(--spacingSm) var(--spacingSm);
    @media (--tablet) {
      padding: var(--spacingLg) var(--spacingMd) var(--spacingMd);
    }
  }

  & .form {
    display: grid;
    grid-gap: var(--spacingSm);
    margin-top: var(--spacingMd);

    @media (--tablet) {
      grid-gap: var(--spacingMd);
      grid-template-columns: repeat(2, 1fr);
    }

    & .payout-input {
      grid-column: span 2;
    }
  }
}
</style>
